import React, { useEffect } from "react";
import "./SellerStories.scss";
import { Link } from "react-router-dom";
import { useAnalytics } from "../../customHooks/reactGA";

import Appbar from "../../components/Appbar/Appbar";
import Footer from "../../components/Footer/Footer";
import Form from "../../components/Form/Form";
import { Box, Button, Typography } from "@mui/material";
import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";

import iconLight from "../../assets/carp_house_plain.png";
import iconDark from "../../assets/carp-house-plain-dark.png";

import video1 from "../../assets/seller-stories/video_1.mp4";
import video2 from "../../assets/seller-stories/video_2.mp4";
import video3 from "../../assets/seller-stories/video_3.mp4";

const SellerStories = (props) => {
  const { trackPageView, trackEvent } = useAnalytics();

  useEffect(() => {
    trackPageView("/seller-stories");
  }, [trackPageView]);

  const videos = [
    {
      id: "v1",
      src: video1,
      title: "Seller Story 1",
      description: "Hear from a homeowner who sold their house to CarpHomes.",
    },
    {
      id: "v2",
      src: video2,
      title: "Seller Story 2",
      description: "Hear from a homeowner who sold their house to CarpHomes.",
    },
    {
      id: "v3",
      src: video3,
      title: "Seller Story 3",
      description: "Hear from a homeowner who sold their house to CarpHomes.",
    },
  ];

  return (
    <div>
      <Appbar colorMode={props.colorMode} theme={props.theme} />

      <section
        className="landing"
        style={{
          backgroundColor:
            props.theme.palette.mode === "dark"
              ? props.theme.palette.primary.dark
              : "#e4e4e4",
          backgroundImage:
            props.theme.palette.mode === "dark"
              ? `url(${iconDark})`
              : `url(${iconLight})`,
        }}
      >
        <div className="flex-container main-text-container">
          <div>
            <h1
              className="heading-title l1 heading-title--pop"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.warning.main
                    : props.theme.palette.primary.main,
              }}
            >
              Real Stories From
              <br />
              Indiana Homeowners
            </h1>
            <p
              className="heading-title l2"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark,
              }}
            >
              Hear directly from homeowners who sold their houses to CarpHomes.
            </p>
          </div>
        </div>
      </section>

      <div className="content-wrapper">
        <Box padding={5} mt={10} mb={10}>
          <VideoPlayer videos={videos} className="seller-stories-player" />
        </Box>
      </div>

      <div className="content-wrapper">
        <section className="contact-form">
          <Box mt={15} mb={10}>
            <Typography
              sx={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.main,
                fontSize: "2rem",
                fontFamily: "karla",
                marginBottom: "0.5em",
                textAlign: "center",
              }}
            >
              Get Your Free, No-Obligation Cash Offer Today
            </Typography>
            <Form theme={props.theme} />
          </Box>

          <Box
            mt={15}
            bgcolor={
              props.theme.palette.mode === "dark"
                ? props.theme.palette.primary.light
                : props.theme.palette.secondary.main
            }
            sx={{ borderRadius: "25px 25px 0 0" }}
          >
            <Box className="contact-us-text-container">
              <Typography
                variant="h4"
                fontSize="2.25rem"
                fontFamily="karla"
                mb={2.5}
                mt={5}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.warning.main
                    : props.theme.palette.primary.dark
                }
              >
                Supplemental Services
              </Typography>
              <Typography
                lineHeight={2.5}
                color={
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark
                }
              >
                In addition to our core focus of purchasing properties directly,
                our team offers supplemental services tailored to specific needs:
              </Typography>

              <Box>
                <ul>
                  <li>
                    <Typography
                      lineHeight={2.5}
                      color={
                        props.theme.palette.mode === "dark"
                          ? props.theme.palette.common.white
                          : props.theme.palette.primary.dark
                      }
                    >
                      <b>Realtor Services - </b>
                      If you're considering selling your home through the
                      traditional market, our team can assist with listing your
                      property and navigating the sales process. While our primary
                      focus is on purchasing homes, this service is available for
                      homeowners who prefer a traditional approach.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      lineHeight={2.5}
                      color={
                        props.theme.palette.mode === "dark"
                          ? props.theme.palette.common.white
                          : props.theme.palette.primary.dark
                      }
                    >
                      <b>Construction Services for Investors - </b>
                      We provide expert construction management services
                      exclusively for real estate investors. Whether you're a
                      seasoned investor or new to the market, we can oversee
                      renovation projects to maximize value and streamline the
                      process. This service is ideal for out-of-state investors
                      looking to expand their portfolio in the Indianapolis area
                      without the hassle of managing projects locally.
                    </Typography>
                  </li>
                </ul>
              </Box>

              <Box mt={10}>
                <Typography
                  variant="h4"
                  fontSize="2.25rem"
                  fontFamily="karla"
                  color={
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.warning.main
                      : props.theme.palette.primary.main
                  }
                  mb={2.5}
                >
                  Sell Your Indiana Home Fast with CarpHomes
                </Typography>
                <Typography
                  lineHeight={2.5}
                  mt={2}
                  color={
                    props.theme.palette.mode === "dark"
                      ? props.theme.palette.common.white
                      : props.theme.palette.primary.dark
                  }
                >
                  We make selling your home easy, fast, and stress-free. As a
                  local Indiana business, we offer cash purchases with no realtor
                  commissions or closing costs. Close in as little as 7 days—no
                  repairs, no open houses, no hassle. Enjoy a private,
                  personalized experience with a team that understands your needs
                  every step of the way.
                </Typography>
              </Box>

              <Box display="flex" justifyContent="center" mt={5}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor:
                      props.theme.palette.mode === "dark"
                        ? props.theme.palette.warning.main
                        : props.theme.palette.primary.main,
                  }}
                  onClick={() => trackEvent("CTA", "Click", "Reach Out")}
                >
                  <Link className="link-item" to="/contact">
                    <Typography color={props.theme.palette.common.white}>
                      Reach Out
                    </Typography>
                  </Link>
                </Button>
              </Box>
            </Box>
          </Box>
        </section>
      </div>

      <Footer theme={props.theme} />
    </div>
  );
};

export default SellerStories;
